import { render } from "./WarningsComponent.vue?vue&type=template&id=78255a23"
import script from "./WarningsComponent.vue?vue&type=script&lang=js"
export * from "./WarningsComponent.vue?vue&type=script&lang=js"

import "./WarningsComponent.vue?vue&type=style&index=0&id=78255a23&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\D_A\\Lockers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__